// extracted by css-extract-rspack-plugin
export default {"FilterTabItem":"UR11M"};